import React from "react";

import { Switch, Route } from "react-router-dom";
import appRoutes, { dashboardRoutes } from "constants/routeConstants";

import Sell from "components/features/Forms/Sell";
import Sales from "components/Dashboard/Sales";
import Purchase from "components/features/Forms/Purchase";
import AddProduct from "components/features/Forms/AddProduct";
import AddCategory from "components/features/Forms/AddCategory";
import AddSupplier from "components/features/Forms/AddSupplier";
import DamagedStock from "components/features/Forms/DamagedStock";
import SalesReturn from "components/features/Forms/AddSalesReturn";
import AddPurchaseReturn from "components/features/Forms/AddPurchaseReturn";
import Purchases from "components/Dashboard/Purchases";
import Products from "components/Dashboard/Products";
import Inventory from "components/Dashboard/Inventory";
import Categories from "components/Dashboard/Categories";
import Suppliers from "components/Dashboard/Suppliers";
import DashboardDisplay from "components/Dashboard/Dashboard";
import Error404 from "components/Error404";
import Ledger from "components/Dashboard/Ledger";

function DashboardRoutes() {
	return (
		<Switch>
			<Route exact path={appRoutes.INDEX} component={DashboardDisplay} />
			<Route path={dashboardRoutes.ADDSALESRECORD} component={Sell} />
			<Route path={dashboardRoutes.SALES} component={Sales} />
			<Route path={dashboardRoutes.PURCHASES} component={Purchases} />

			<Route path={dashboardRoutes.ADDPRODUCTS} component={AddProduct} />

			<Route
				path={dashboardRoutes.ADDPURCHASERECORD}
				component={Purchase}
			/>

			<Route
				path={dashboardRoutes.ADDSTOCKRETURN}
				component={AddPurchaseReturn}
			/>

			<Route path={dashboardRoutes.ADDCATEGORY} component={AddCategory} />

			<Route path={dashboardRoutes.ADDSUPPLIER} component={AddSupplier} />
			<Route
				path={dashboardRoutes.ADDSTOCKDAMAGED}
				component={DamagedStock}
			/>
			<Route
				path={dashboardRoutes.ADDSALESRETURN}
				component={SalesReturn}
			/>

			<Route path={dashboardRoutes.VIEWPRODUCTS} component={Products} />
			<Route path={dashboardRoutes.VIEWINVENTORY} component={Inventory} />
			<Route
				path={dashboardRoutes.VIEWCATEGORIES}
				component={Categories}
			/>
			<Route path={dashboardRoutes.VIEWSUPPLIERS} component={Suppliers} />

			<Route path={dashboardRoutes.VIEWLEDGER} component={Ledger} />

			<Route path={"/**"} component={Error404} />
		</Switch>
	);
}

export default DashboardRoutes;
